















































import { Component, Vue, Watch } from "vue-property-decorator";
import { Articoli } from "@/models/entities/articoli.interface";
import { articoliservice } from "@/services/api/articoli.service";
import { Table } from "@/models/entities/table.interface";
import ReloadModule from "@/store/modules/reload.module";
import LastUpdateModule from "@/store/modules/lastUpdate.module";
import store from "@/store/index";
import { getModule } from "vuex-module-decorators";
import { saveExcel } from "@progress/kendo-vue-excel-export";
const lastUpdateModule = getModule(LastUpdateModule, store);
const reloadModule = getModule(ReloadModule, store);

@Component({
  components: {},
})
export default class Tondi extends Vue {
  public loading = false;
    private table: Table<Articoli> = {
        sortBy: ["qualita", "misura"],
        sortDesc: [false, false],
    headers: [
      { text: "Articolo", value: "articolo", filterable: false },
      { text: "Qualità", value: "qualita" },
      { text: "Misura (mm)", value: "misura", sortable: false },
      {
        text: "Quantità (Kg)",
        value: "quantita",
        sortable: false,
        filterable: false,
        },
        {
            text: "Prossima produzione",
            value: "dataPrevistaProduzione",
            sortable: false,
            filterable: false,
        },
    ],
    items: [],
    search: "",
  };
  async created(): Promise<void> {
    // overlayModule.showOverlay();
    await this.loadTable();
  }

  private customsort(
    items: Array<Articoli>,
    sortBy: string[],
    sortDesc: boolean[]
  ): Array<Articoli> {
    try {
      if (!sortBy || sortBy.length == 0) {
        return items;
      } else if (sortBy && sortBy.length == 1 && sortBy[0] == "qualita") {
        return items.sort((a, b) => {
          if (a.qualita > b.qualita) {
            return sortDesc[0] ? 1 : -1;
          }
          if (a.qualita < b.qualita) {
            return sortDesc[0] ? -1 : 1;
          }
          if (a.qualita == b.qualita) {
            if (Number(a.misura) > Number(b.misura)) return 1;
            if (Number(a.misura) < Number(b.misura)) return -1;
            return 0;
          }
        });
      } else if (sortBy && sortBy.length == 1) {
        return items.sort((a, b) => {
          if (a[sortBy[0]] > b[sortBy[0]]) {
            return sortDesc[0] ? 1 : -1;
          }
          if (a[sortBy[0]] < b[sortBy[0]]) {
            return sortDesc[0] ? -1 : 1;
          }
          if (a[sortBy[0]] == b[sortBy[0]]) {
            return 0;
          }
        });
      }
    } catch {
      console.log("err");
    }
    return items;
  }

  get reload(): boolean {
    return reloadModule.status;
  }

  @Watch("reload")
  reloadChanged() {
    if (this.reload) {
      this.loadTable();
    }
  }

  async loadTable(): Promise<void> {
    const r = await articoliservice.readAll("TT");
    this.$set(this.table, "items", r.data);
    reloadModule.hideReload();

     if(r.data.length>0)
      lastUpdateModule.setLastUpdateDate(r.data[0].ultimoAggiornamentoFile);
  }

  async exportTable() {
    var myData = [];
    var date = new Date();
    var filename =
      date.getDate() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      date.getFullYear() +
      "_";
    this.table.items.forEach((element) => {
      myData.push({
        Articolo: element.articolo,
        Qualita: element.qualita,
        Misura: element.misura,
        Quantita: element.quantita,
        PrevProd: element.dataPrevistaProduzione
      });
    });
    saveExcel({
      data: myData,
      fileName: filename + "Tondi",
      columns: [
          { field: "Articolo", title: "Articolo" },
        { field: "Qualita", title: "Qualità" },
        { field: "Misura", title: "Misura (mm)" },
        { field: "Quantita", title: "Quantità (Kg)" },
        { field: "PrevProd", title: "Prossima produzione" },
      ],
    });
  }
}
